import AdminModeCheckbox from "../AdminModeCheckbox";
import AdminNavBar from "../AdminNavBar";
import * as S from "./styles";

const AdminPageHeader: React.FC = () => {
  return (
    <S.AdminPageHeaderContainer>
      <AdminModeCheckbox style={{ padding: 0 }} />
      <AdminNavBar />
    </S.AdminPageHeaderContainer>
  );
};

export default AdminPageHeader;
